import { ReactNode } from 'react';
import Sidebar from './Sidebar';
import { useAuth } from '../lib/auth';

export default function AppShell({ children }: { children: ReactNode }) {
  const user = useAuth((s) => s.user);
  const logout = useAuth((s) => s.logout);
  return (
    <div className="min-h-screen flex bg-dg-ink text-white">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <header className="h-14 border-b border-dg-border px-6 flex items-center justify-between bg-dg-navy/40">
          <div className="text-xs uppercase tracking-[0.2em] text-dg-mist">
            DG Agent Launch
          </div>
          <div className="flex items-center gap-4 text-sm">
            {user ? (
              <span className="text-dg-text-2">
                {user.firstName} {user.lastName}
              </span>
            ) : null}
            <button
              onClick={() => logout()}
              className="text-dg-mist hover:text-white"
            >
              Sign out
            </button>
          </div>
        </header>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </main>
    </div>
  );
}
